/* eslint-disable import/extensions */
import { IdleQueue } from 'idlize/IdleQueue.mjs'
import '@modules/lazysizes'
import header from '@components/header/header'

const loader = () => {
  setTimeout(() => {
    header.mount()
  }, 0)

  /** *************
   * when idle
   */

  const queue = new IdleQueue()
  queue.pushTask(() => {
    if (document.querySelector('details')) {
      import(
        /* webpackChunkName: "accordion" */
        '@magnetita/accordion'
      )
    }
  })
}

export default { loader }
